import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons"

export const ChevronLeft = (props) => {
  return <FontAwesomeIcon faIcon={faChevronLeft} {...props} />
}
